



































































































































































import Event from '@/models/event';
import Dialog from '@/components/Dialog.vue';
import moment, { Moment } from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AdvancedFilter, emptyAdvancedFilter } from './EventsList.vue';

@Component({
  components: {
    Dialog,
  },
})
export default class AdvancedFilterDialog extends Vue {
  public readonly hiTestFilterOptions: any = [
    { text: 'Hide HI-Tests', value: false },
    { text: 'Only HI-Tests', value: true },
  ];

  @Prop() private availableDays!: string[];
  @Prop() private availableTestTypes!: string[];
  @Prop() private includeMetatopiaFilters!: boolean;
  @Prop() private parentFilter!: AdvancedFilter;

  private availableSorts: object[] = [
    {
      text: 'Sort by time',
      value: 'time',
    },
    {
      text: 'Sort by code',
      value: 'code',
    },
  ];
  private showAdvancedFilter: boolean = false;
  private filterStartTimeMenu: boolean = false;
  private filterStartTimeIndex: string = '';
  private advancedFilterIndex: AdvancedFilter = Object.assign({}, this.parentFilter);

  @Watch('parentFilter')
  private onFilterReset(): void {
    this.advancedFilterIndex = Object.assign({}, this.parentFilter);
  }

  private allowedMinutes(minutes: number): boolean {
    return this.eventMinutesStart.has(minutes);
  }

  private allowedHours(minutes: number): boolean {
    return this.eventHoursStart.has(minutes);
  }

  get filterStartTime12H(): string | null {
    return this.advancedFilterIndex.filterStartTime
      ? moment(this.advancedFilterIndex.filterStartTime, 'HH:mm').format('h:mmA')
      : null;
  }

  set filterStartTime12H(val: string | null) {
    this.advancedFilterIndex.filterStartTime = val
      ? moment(val, 'h:mmA').format('HH:mm')
      : null;
  }

  get eventMinutesStart(): Set<number> {
    return Object.values(this.$store.state.schedule)
      .reduce(
        (acc: any, e: any) => acc.add(e.startTime.minutes()),
        new Set<number>(),
      ) as Set<number>;
  }

  get eventHoursStart(): Set<number> {
    return Object.values(this.$store.state.schedule)
      .reduce(
        (acc: any, e: any) => acc.add(e.startTime.hours()),
        new Set<number>(),
      ) as Set<number>;
  }

  private handleHourClicked(hour: number): void {
    if (this.eventMinutesStart.size > 1) {
      return;
    }
    this.filterStartTimeIndex = `${hour}:00`;
  }

  private closeAdvancedFilter(): void {
    Object.assign(this.advancedFilterIndex, this.parentFilter);
    this.showAdvancedFilter = false;
  }

  private applyAdvancedFilter(): void {
    this.$emit('apply', this.advancedFilterIndex);
    this.showAdvancedFilter = false;
  }

  private clearAdvancedFilter(): void {
    this.$emit('apply', Object.assign({}, emptyAdvancedFilter));
    this.showAdvancedFilter = false;
  }

  private dialogClosed(): void {
    Object.assign(this.advancedFilterIndex, this.parentFilter);
  }
}
